// src/components/mediaKit/SocialEmbed.jsx
import React, { useEffect, useRef } from 'react';

function loadScriptOnce(src, id) {
    if (document.getElementById(id)) return Promise.resolve();
    return new Promise((resolve) => {
        const s = document.createElement('script');
        s.src = src;
        s.id = id;
        s.async = true;
        s.onload = resolve;
        document.body.appendChild(s);
    });
}

function tiktokVideoId(url) {
    const m = url.match(/\/video\/(\d+)/);
    return m ? m[1] : null;
}

export function TikTokEmbed({ url }) {
    const ref = useRef(null);
    const videoId = tiktokVideoId(url);

    useEffect(() => {
        loadScriptOnce('https://www.tiktok.com/embed.js', 'tiktok-embed-script').then(() => {
            // TikTok's script only auto-scans on load; re-run its scan for embeds added after that
            if (window.tiktokEmbedLoad) window.tiktokEmbedLoad();
        });
    }, [url]);

    if (!videoId) {
        return (
            <div className="p-6 text-center text-sm text-slate-400">
                Couldn't identify this TikTok video. <a href={url} target="_blank" rel="noreferrer" className="text-blue-500 underline">Open on TikTok</a>
            </div>
        );
    }

    return (
        <blockquote
            ref={ref}
            className="tiktok-embed"
            cite={url}
            data-video-id={videoId}
            style={{ maxWidth: 605, minWidth: 325, margin: '0 auto' }}
        >
            <section />
        </blockquote>
    );
}

export function InstagramEmbed({ url }) {
    useEffect(() => {
        loadScriptOnce('https://www.instagram.com/embed.js', 'instagram-embed-script').then(() => {
            if (window.instgrm) window.instgrm.Embeds.process();
        });
    }, [url]);

    return (
        <blockquote
            className="instagram-media"
            data-instgrm-permalink={url}
            data-instgrm-version="14"
            style={{ background: '#FFF', border: 0, margin: '0 auto', maxWidth: 540, width: '99%' }}
        />
    );
}